import React from 'react'

import PortalModal from "./PortalModal"
import Backend from '../../utils/Backend'
import Notify from '../../utils/Notify'
import Cart from "../../utils/Cart";
import General from "../../utils/General";

export default class ProductVariantsModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
      product: props.product,
      variantOptions: props.variantOptions,
      show: props.show,
      variant: [],
      selectedOptions: [],
      options: [],
      colorSwatchesType: "square",
      colorSwatchesValue: "",
      variant1Type: "btn_horizontal",
      variant1Value: "",
    }
  }

  componentDidMount(){

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _onAddToCartPressed(){
    let {
      variant,
      product,
      variantOptions
    } = this.state

    if(variant.length !== Object.entries(variantOptions).length){
      Notify.error("Please select all product options")
      return
    }

    variant = Cart.getVariant(product, variant)

    this.props.onSelected(product, variant)
    this.setState({ variant: [] })
  }

  _renderAddToCart(){
    let {
      product,
      variant,
    } = this.state

    return (
      <>
        <a
          className="btn btn--primary"
          style={{
            color: "white",
            borderColor: "#222",
            backgroundColor: "#222"
          }}
          onClick={() => this._onAddToCartPressed()}
        >
          Add To Cart
        </a>
      </>
    )
  }

  handleVariantChange(index, isColor, key) {
    return (e) => {
      const selectedOptionName = e.target.value;
      const variant = [...this.state.variant];

      if (selectedOptionName === key[0]) {
        variant[index] = null;
      } else {
        variant[index] = selectedOptionName;
      }

      this.setState({ variant }, () => {
        setTimeout(() => {
          General.updateSlides();
          General.updateLazyBackgroundImages();
        }, 50);
      });
    };
  }

  _renderProductVariants(){
    let {
      variantOptions
    } = this.state

    return Object.entries(variantOptions).map((key, index) => {
      return this._renderVariant(key, index, key[0].toLowerCase() === 'color')
    })
  }

  _renderVariant(key, index, isColor){
    let {
      variant,
      variant1Type,
      variantOptions,
      colorSwatchesType,
    } = this.state

    if(isColor && !variantOptions.Color){
      return
    }

    const title = isColor ? 'Color' : key[0];
    const options = isColor ? variantOptions.Color : key[1];
    const selectType = isColor ? colorSwatchesType : variant1Type;

    return (
      <div
        className={`${isColor ? 'color-swatches' : 'sizes'} mb-3 my-28px`}
      >
        <h4 className="mb-2">{title}</h4>
        {
          selectType === 'dropdown' ?
            <div className="input-select">
              <select
                value={variant[index]}
                onChange={this.handleVariantChange(index, isColor, key)}
              >
                {options.map((option, optionIndex) => {
                  return (
                    <option key={optionIndex} value={option}>
                      {option}
                    </option>
                  )
                })}
              </select>
            </div>
            :
            <div className={`items ${selectType}`}>
              {options.map((option, optionIndex) => {
                return (
                  <div
                    key={optionIndex}
                    className="item input-radio input-radio--innerlabel"
                    title={option}
                  >
                    <input
                      type="radio"
                      name={isColor ? 'colors' : key[0]}
                      value={option}
                      id={`${isColor ? 'color' : key[0]}-${optionIndex}`}
                      checked={variant[index] === option}
                      onChange={this.handleVariantChange(index, isColor, key)}
                    />
                    <label htmlFor={`${isColor ? 'color' : key[0]}-${optionIndex}`} className={isColor ? '' : 'btn'}>
                      {isColor ? <span className='color' style={{ backgroundColor: option }}></span> : option}
                      {isColor ? <span className='name'>{option}</span> : null}
                    </label>
                  </div>
                )
              })}
            </div>
        }
      </div>
    )
  }

  render() {
    let {
      show,
      loading,
      product,
      options,
      variant,
      variantOptions,
      selectedOptions
    } = this.state

    if(!show){
      return null
    }

    let showAddToCart = Cart.showAddToCart(product, variant)

    return (
      <PortalModal
        show={show}
        id='icon-picker-modal'
        contentSuperContainerClassName="image-picker-modal"
        onHide={() => this.props.onHide()}
      >
        <h3>{product.productName}</h3>

        {this._renderProductVariants()}

        <div className="c-btn-group text-right mt-5">
          <a
            className="btn btn--secondary"
            style={{
              color: "#222",
              borderColor: "#222",
              backgroundColor: "transparent"
            }}
            onClick={() => this.props.onHide()}
          >
              Cancel
          </a>
          <a
            className="btn btn--primary"
            style={{
              color: "white",
              borderColor: "#222",
              backgroundColor: "#222"
            }}
            onClick={() => this._onAddToCartPressed()}
          >
            Add To Cart
          </a>
        </div>
      </PortalModal>
    )
  }
}
